<header class="header">
  <div *ngIf="!isHeaderBannerClosed" class="ado-header-banner banner-width">
    <div
      (click)="handleCloseHeaderBanner()"
      class="banner-close-icon d-flex justify-content-center align-items-center"
    >
      <img src="/assets/images/close.svg" />
    </div>
    <div
      *ngIf="!isHeaderBannerClosed"
      id="ado-6a2hNgFSzE498oFHKPX7Zu45zTjhpidCqdX47K8THXL.N7"
    ></div>
  </div>

  <div
    class="header-sup align-items-center d-none d-xl-flex justify-content-between"
  >
    <div
      class="container container__custom-width d-flex justify-content-between"
    >
      <nav class="navbar p-0">
        <ul
          class="nav navbar-nav navbar-center f-size-13 f-color-white flex-row"
        >
          <li
            class="nav-item text-white"
            *ngFor="let item of headerSupNavLinks"
          >
            <a [href]="item.url" class="text-decoration-none">
              {{ item.title }}
            </a>
          </li>
        </ul>
      </nav>
      <a
        href="tel:0322158686"
        class="f-size-13 d-flex align-items-center f-color-white"
      >
        <img src="/assets/images/phone-icon.svg" alt="phone-icon" />
        <span class="ml-2">0 32 2 15 86 86</span>
      </a>
    </div>
  </div>
  <nav
    class="navbar container container__custom-width navbar-expand-xl navbar-light bg-white py-3"
  >
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation"
      #navDropdownButton
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <a [routerLink]="'/'" class="navbar-brand mr-xl-5">
      <img src="/assets/images/logo.svg" alt="logo" />
    </a>
    <div class="d-flex">
      <a
        *ngIf="!isUserAuthenticated"
        [routerLink]="'/auth/login'"
        class="d-xl-none"
      >
        <img class="m-2" src="/assets/images/user.svg" alt="user" />
      </a>
    </div>

    <div class="burger-menu position-absolute">
      <div
        class="navbar-collapse collapse burger-menu-content position-fixed w-100 h-100"
        id="navbarNavDropdown"
        #burgerMenu
      >
        <nav>
          <ul class="navbar-nav container align-items-start px-3 py-3">
            <li class="w-100">
              <a
                [href]="headerSupNavLinks[0].url"
                class="f-color-dark f-size-14 text-decoration-none"
              >
                <p class="burger-menu-content__item nav-item m-0">
                  {{ headerSupNavLinks[0].title }}
                </p>
              </a>
            </li>
            <li
              #navbarDropdownItem
              class="burger-menu-content__item nav-item d-flex justify-content-between position-relative f-size-14 cursor-pointer"
              data-toggle="collapse"
              data-target="#burgerMenuItemChildren"
              aria-controls="burgerMenuItemChildren"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              სხვა სერვისები
              <img src="/assets/images/arrow-down-light.svg" alt="arrow" />
              <ul
                class="burger-menu-content__item__child-list align-items-start navbar-collapse navbar-nav collapse text-decoration-none"
                id="burgerMenuItemChildren"
              >
                <li
                  *ngFor="let item of headerSupNavLinks.slice(1)"
                  class="py-2"
                >
                  <a
                    [href]="item.url"
                    class="f-color-slate f-size-14 text-decoration-none"
                    >{{ item.title }}</a
                  >
                </li>
              </ul>
            </li>
            <!-- <li *ngFor="let item of headerSupNavLinks.slice(1)" #navbarDropdownItem  class="burger-menu-content__item nav-item px-2">
              {{item.title}}
            </li> -->
            <!-- <li #navbarDropdownItem  class="burger-menu-content__item nav-item px-2">
              <span class="cursor-pointer f-color-dark f-size-14 text-left"
              (click)="openModal('WithdrawBalanceComponent')">გატანა</span>
            </li> -->
          </ul>
        </nav>
      </div>
    </div>

    <div *ngIf="isUserAuthenticated" class="header__logout d-xl-none">
      <a
        class="d-xl-none"
        (click)="openModal('ProfileNavbarComponent')"
        class="cursor-pointer"
      >
        <img class="m-2" src="/assets/images/user.svg" alt="user" />
      </a>
    </div>

    <div
      class="collapse navbar-collapse justify-content-end"
      id="navbarSupportedContent"
    >
      <!-- <ul class="navbar-nav mr-auto">
        <li class="nav-item dropdown mr-4">
          <a class="f-color-dark" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            კატეგორიები
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item">Action</a>
            <a class="dropdown-item">Another action</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item">Something else here</a>
          </div>
        </li>
        <li class="nav-item">
          <a class="f-color-dark">დღევანდელი აუქციონები</a>
        </li>
      </ul> -->
      <form class="form-inline my-2 my-xl-0">
        <button
          class="btn btn-primary rounded-pill bg-vibrant-blue"
          [ngClass]="{ 'mr-3': isUserAuthenticated }"
          routerLink="/warning"
        >
          შეტყობინება
        </button>

        <a
          *ngIf="userCanManageAuctions"
          [routerLink]="isUserAuthenticated ? '/auction/create' : '/auth/login'"
          class="btn btn-link header__btn-add-auction mr-4"
        >
          დაამატე აუქციონი
        </a>

        <div *ngIf="isUserAuthenticated" class="header__balance">
          <div class="d-flex align-items-center mr-3">
            <div class="circle-45 border mr-2">
              <img src="/assets/images/wallet.svg" />
            </div>
            <div>
              <p class="mb-0 f-size-14">ბალანსი</p>
              <p class="mb-0 f-size-16 fw-medium">
                {{ getBalance | priceFormatter }} ₾
                <img
                  class="header__balance__arrow ml-1"
                  src="/assets/images/arrow-down.svg"
                />
              </p>
            </div>
          </div>
          <div class="header__balance__dropdown">
            <button
              class="btn btn-link f-color-dark text-decoration-none f-size-14 w-100 text-left"
              (click)="openModal('FillBalanceComponent')"
            >
              შემოტანა
            </button>
            <button
              class="btn btn-link f-color-dark text-decoration-none f-size-14 w-100 text-left"
              (click)="openModal('WithdrawBalanceComponent')"
            >
              გატანა
            </button>
          </div>
        </div>

        <a
          *ngIf="!isUserAuthenticated"
          routerLink="/auth/login"
          class="btn btn-link f-color-dark pr-0 d-flex align-items-center"
        >
          <span class="user-image rounded-circle mr-2">
            <img src="/assets/images/user.svg" alt="user" />
          </span>
        </a>

        <div class="header__logout" *ngIf="isUserAuthenticated">
          <a
            routerLink="/profile/my-auctions"
            class="btn btn-link f-color-dark pr-0 d-flex align-items-center"
          >
            <span class="user-image rounded-circle mr-2">
              <img src="/assets/images/user.svg" alt="user" />
            </span>
            ანგარიში
          </a>
          <div class="header__logout__dropdown">
            <a [routerLink]="'/profile'">
              <button class="btn btn-link f-color-dark">პროფილი</button>
            </a>
            <a *ngIf="getIsAdmin" [routerLink]="'/admin'">
              <button class="btn btn-link f-color-dark">ადმინი</button>
            </a>
            <button class="btn btn-link f-color-dark" (click)="logout()">
              გასვლა
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="t-net__container cursor-pointer">
      <div
        #toggleButton
        (click)="tnetModalShowfunc(!tnetDropDown)"
        (mouseover)="tnetLogoHovered(true)"
        (mouseleave)="tnetLogoHovered(false)"
        [class]="{ colored: tnetDropDown }"
        class="t-net__container-logo"
      >
        <ng-template [ngIf]="!tnetDropDown">
          <img
            *ngIf="!tNetLogoColored"
            class="hovered tnet-logo"
            src="/assets/images/tnet-logo-unhovered.svg"
          />
          <img
            *ngIf="tNetLogoColored"
            class="unhovered tnet-logo"
            src="/assets/images/tnet-logo-hovered.svg"
          />
        </ng-template>
        <ng-template [ngIf]="tnetDropDown">
          <img
            ref="tnetCompanies"
            class="tnet-logo"
            src="/assets/images/tnet-logo-active.svg"
          />
        </ng-template>
      </div>
      <app-t-net-companies></app-t-net-companies>
    </div>
  </nav>
</header>

<!-- <div *ngIf="isOutBalanceModalOpen" class="custom-modal">
  <form [formGroup]="form">
    <button class="custom-modal__bg" (click)="closeOutBalanceModal()"></button>
    <div class="custom-modal__component">
      <div *ngIf="getOutModalStep === 1" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><button class="btn btn-link f-color-dark f-size-14 pl-0">გადახდა</button></h5>
          <button type="button" class="close" (click)="closeOutBalanceModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h1 class="f-size-24 fw-bold mb-4">აირჩიეთ გატანის ტიპი</h1>
          <div class="d-flex flex-md-row flex-column align-items-center justify-content-between">
            <div class="d-flex align-items-center form-group">
              <div class="circle-45 border mr-3">
                <img src="/assets/images/credit-card-blue.svg" />
              </div>
              <div>
                <h4 class="f-size-16 fw-medium">ანგარიში</h4>
                <p class="mb-0 f-size-14">GETB3213131000700512 ·<span class="f-color-success-green">115₾</span></p>
              </div>
            </div>
            <app-text-input formControlName="price" placeholder="მიუთითეთ თანხა"></app-text-input>
          </div>

          <div class="w-100 d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-primary bg-vibrant-blue col-3 fw-medium py-3 col-sm-4 col-6"
              data-dismiss="modal" (click)="outModalSecondStep()">თანხის გატანა</button>
          </div>
        </div>
        <button type="button" class="btn btn-primary" (click)="auctionDelete(isBalanceModalOpen)">წაშლა</button>
      </div>
      <div *ngIf="getOutModalStep === 2" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><button
              class="btn btn-link pl-0 f-color-dark f-size-14 custom-modal__component__btn-left-arrow"
              (click)="outModalFirstStep()">უკან</button></h5>
          <button type="button" class="close" (click)="closeOutBalanceModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <h1 class="f-size-30 fw-bold mb-3">SMS-კოდი გამოგზავნილია</h1>
          <p class="f-size-16 fw-regular f-color-balance-modal-text mb-4">
            ჩვენ გამოგიგზავნეთ SMS დასტურის კოდი ნომერზე <span class="fw-medium">{{ getUserPhoneNumber }}</span>,
            რომელიც მითითებული გაქვთ თქვენი ანგარიშის ძირითად ნომრად
          </p>

          <p class="f-size-14">შეიყვანე 4-ნიშნა კოდი, რომელიც მიიღე ნომერზე {{ getUserPhoneNumber }};</p>
          <app-text-input formControlName="phone_code" placeholder="XXXX შეიყვანეთ კოდი" class="mx-auto col-8">
          </app-text-input>
          <p class="f-size-14">არ მიგიღიათ კოდი?
            <span *ngIf="getTimer" class="f-color-balance-modal-text">სცადე {{ getTimer }} წამში</span>
            <button *ngIf="!getTimer" class="btn btn-link f-size-14 f-color-balance-modal-text fw-medium p-0" (click)="sendSms()">სცადე თავიდან</button>
            ან
            <a class="fw-medium">დაგვიკავშირდით</a>
          </p>
        </div>
      </div>
      <div *ngIf="getOutModalStep === 3" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><button
              class="btn btn-link pl-0 f-color-dark f-size-14 custom-modal__component__btn-left-arrow"
              (click)="outModalFirstStep()">უკან</button></h5>
          <button type="button" class="close" (click)="closeOutBalanceModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="getTransactionSuccess" class="d-flex align-items-center flex-column pt-4 text-center">
            <img class="mb-3" src="/assets/images/success_1.svg" />

            <h2 class="f-size-22 fw-bold f-color-black mb-3">ტრანზაქცია წარამტებით განხორციელდა</h2>

            <p class="f-color-action-text mb-4">თანხა გადმორიცხულია თქვნეს მითითებულ ანგარიშზე,
              რომელიც აისახება 2 სამუშაო დღის განმვალობაში</p>

            <button type="button" class="btn btn-primary bg-vibrant-blue col-md-4 col-8 fw-medium py-3 mb-5"
              data-dismiss="modal" (click)="closeOutBalanceModal()">დახურვა</button>

          </div>
          <div *ngIf="!getTransactionSuccess" class="d-flex align-items-center flex-column pt-4 text-center">
            <img class="mb-3" src="/assets/images/red-error.svg" />

            <h2 class="f-size-22 fw-bold f-color-black mb-3">ტრანზაქცია ვერ განხორციელდა</h2>

            <p class="f-color-action-text mb-4">აქ ჩაიწერება მიზეზი რის გამოც ვერ გადაირიცხა</p>

            <button type="button" class="btn btn-primary bg-vibrant-blue col-md-4 col-7 fw-medium py-3 mb-5"
              data-dismiss="modal" (click)="outModalFirstStep()">სცადეთ თავიდან</button>

          </div>
        </div>
      </div>
    </div>
  </form>
</div> -->
